export default __webpack_public_path__ + "static/media/good.5518edbf.png";